<template>
  <Picker
    :data="emojiIndex"
    :native="true"
    :show-preview="false"
    :show-search="true"
    :i18n="i18n"
    :emoji-size="20"
    @select="addEmoji"
    set="google"
    :sheetsize="16"
  />
</template>

<script>
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import data from 'emoji-mart-vue-fast/data/google.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'

const emojiIndex = new EmojiIndex(data)

export default {
  components: {
    Picker
  },

  props: {

    disabled: {
      type: Boolean,
      default: false
    },

    value: {
      type: String
    }
  },

  data () {
    return {
      i18n,
      emojiIndex,
      text: forceStr(this.value)
    }
  },

  methods: {
    addEmoji ({ native }) {
      this.text = this.text.concat(native)
    }
  },

  watch: {
    text (text) {
      if (isEqual(text, this.value)) return
      this.$emit('input', forceStr(text))
    },

    value (value) {
      if (isEqual(this.text, value)) return
      this.text = forceStr(value)
    }
  }
}

const i18n = {
  search: 'Pesquisar emojis',
  categories: {
    search: 'Resultados de busca',
    recent: 'Recentes',
    smileys: 'Smileys e emoticons',
    people: 'Gestos e Pessoas',
    nature: 'Animais & Natureza',
    foods: 'Comidas & Bebidas',
    activity: 'Atividades',
    places: 'Viagens & Lugares',
    objects: 'Objetos',
    symbols: 'Simbolos',
    flags: 'Bandeiras'
  }
}
const forceStr = (val) => String(val || '')
const isEqual = (source, target) => forceStr(source) === forceStr(target)

</script>

<style lang="sass">
  .emoji-mart-category-label
    margin-top: 10px
    h3
      font-weight: 500
      font-size: 12px
      font-family: Roboto
      font-style: bold
      color: #263238
      margin: 5px 5px 5px 0
      padding-bottom: 0
      padding-top: 2px

  .emoji-mart-search
    input
      font-size: 15px
      font-family: Roboto
      font-style: bold
      color: #263238

</style>
